import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import NavigationBar from './components/Navbar';
import Home from './components/Home';
import Projects from './components/Projects';
import CV from './components/CV';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Footer from './components/Footer';

import './assets/main.scss';


ReactGA.initialize("G-4DZNQG4ZES");

// Wrapper component for tracking page views
const PageViewTracker = ({ children }) => {
  const location = useLocation();

  React.useEffect(() => {
    try {
      // Scroll to top on route change
      window.scrollTo(0, 0);

      // Enhanced page view tracking with additional data
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
        title: document.title,
        location: window.location.href,
        referrer: document.referrer
      });
    } catch (error) {
      console.error('Failed to track page view:', error);
    }
  }, [location]);

  return children;
};

// Export analytics functions for use in other components
export const trackEvent = (category, action, label) => {
  try {
    ReactGA.event({
      category,
      action,
      label
    });
  } catch (error) {
    console.error('Failed to track event:', error);
  }
};

const App = () => {
  return (
    <Router>
      <PageViewTracker>
        <div className="App">
          <NavigationBar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/cv" element={<CV />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/gallery" element={<Gallery />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </PageViewTracker>
    </Router>
  );
};

export default App;
